import React, { useRef } from 'react'
import './Expirience.css'
import { experienceData } from '../Data'
import Slider from 'react-slick';

function Expirience() {
    const slideRef = useRef();

    const settings = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 2, // Corrected property name
      slidesToScroll: 1, // Corrected property name
      arrows: false, // Corrected property name
      responsive: [
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 1, // Corrected property name
            slidesToScroll: 1, // Corrected property name
          },
        },
      ],
    };
    return (
        <div className='container'>
            <div className="Expirience-container">
                <h4>Work Expirience</h4>

                <div className="Expirience-content">
                    <Slider ref={slideRef} {...settings}>
                    {experienceData.map((expirience) => (
                        <div className='work-expirience-card'>
                            <h3>{expirience.position}</h3>
                            <div className="work-duration">{expirience.company}</div>

                            <ul>
                                {expirience.responsibilities.map((responsibility, i) => (
                                    <li key={i}>{responsibility}</li>
                                ))}
                            </ul>
                        </div>
                    ))}
                    </Slider>
                </div>
            </div>
        </div>
    )
}

export default Expirience